import type { TOC } from '@ember/component/template-only';
import Table from 'tio-ui/components/table';
import { PhInfo } from 'ember-phosphor-icons';
import { t } from 'ember-intl';
import safeFormatDate from 'tio-common/helpers/safe-format-date';
import type { DependentExtension as DependentModel } from 'tio-data/data/resources/dependent.ext';

interface FamilyMembersListSignature {
  Args: {
    dependents: DependentModel[];
    companyName: string;
  };
}

const FamilyMembersList: TOC<FamilyMembersListSignature> = <template>
  <div class="tio-flex p-4 tio-bg-info-soft border tio-border-info rounded mb-4">
    <PhInfo @size="20" class="tio-fg-info shrink-0 mt-0.5" />
    <div class="text-sm tio-fg-secondary">
      <strong>{{t "profile.family.info_title"}}</strong>
      <p class="mt-1">
        {{t "profile.family.info_description" employer=@companyName}}
      </p>
    </div>
  </div>

  {{#if @dependents.length}}
    <Table>
      <:thead as |head|>
        <head.tr>
          <head.th>{{t "profile.family.name_label"}}</head.th>
          <head.th>{{t "profile.family.invited_label"}}</head.th>
          <head.th>{{t "profile.family.enrolled_label"}}</head.th>
          <head.th>{{t "profile.family.relationship_label"}}</head.th>
        </head.tr>
      </:thead>
      <:tbody as |body|>
        {{#each @dependents as |dependent|}}
          <body.tr>
            <body.td>
              <div class="font-semibold tio-fg-primary">{{dependent.fullName}}</div>
            </body.td>
            <body.td>
              {{safeFormatDate dependent.createdAt}}
            </body.td>
            <body.td>
              {{safeFormatDate dependent.enrolledDate}}
            </body.td>
            <body.td>
              {{dependent.relationshipLabel}}
            </body.td>
          </body.tr>
        {{/each}}
      </:tbody>
    </Table>
  {{else}}
    <div class="tio-fg-muted text-center py-8">
      {{t "profile.family.empty_state"}}
    </div>
  {{/if}}
</template>;

export default FamilyMembersList;
